import Model from './Model'

export default class Organization extends Model {
    static async current() {
        return this.make(await Http.get(route('api.v2.organization.organization')))
    }

    async invite(id, name, emailAddressOrPhoneNumber, permissions) {
        await Http.post(route('api.v2.organization.organization.invite', {id}), {name, emailAddressOrPhoneNumber, permissions});
        Object.assign(this, await Organization.current())
    }

    async updatePermissions(userId, permissions) {
        await Http.put(route('api.v2.organization.organization.permissions.update', {userId}), permissions);
        Object.assign(this, await Organization.current())
    }

}
